import { createAction, props } from '@ngrx/store';
import { GeneralState } from '@states/general/general.reducer';

export const resetToInitialState = createAction('[GENERAL] Reset to Initial state');

export const setGeneral = createAction('[GENERAL] Set General Options', props<{ generalState: GeneralState }>());

export const getGeneralFromBackend = createAction('[GENERAL] Set General Options From Backend');
